import { forwardRef } from 'react'
import { PreviewCard as BasePreviewCard } from '@base-ui/react/preview-card'
import { twMerge } from 'tailwind-merge'
import { popupSurface } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'
import { Interactive } from '../../interactive'

export interface PopupProps extends PartProps<BasePreviewCard.Popup.Props> {
  className?: string
}

/**
 * Popover's surface, with an entrance fade. A menu lands at once because it answers a click;
 * a preview opens on hover, so it fades in the same way it fades out.
 *
 * forwardRef because callers measure this rect, and React 18 silently drops a
 * ref passed to a plain function component.
 */
export const Popup = forwardRef<HTMLDivElement, PopupProps>(function Popup({ className, children, ...props }, ref) {
  return (
    <BasePreviewCard.Popup
      ref={ref}
      className={twMerge(
        popupSurface,
        'data-[starting-style]:opacity-0',
        'relative flex w-64 flex-col gap-3 break-words p-3 text-sm',
        className,
      )}
      {...props}
    >
      <Interactive>{children}</Interactive>
    </BasePreviewCard.Popup>
  )
})
